import { Typography } from 'antd';
import useColors from '../../hooks/useColors';
import TextInput from './text-input';

export default function URLInput({ ...rest }) {
    const { colorPrimary } = useColors();
    return (
        <>
            <TextInput {...rest} />
            <Typography.Text className="text-xs mt-2 pl-2 font-semibold">
                <span style={{ color: colorPrimary }}>Preview</span>: http://
                {rest.value ? `${rest.value}.` : ''}guardsconnect.5stardesigners.net/qa/
            </Typography.Text>
        </>
    );
}
